import type { ReactNode } from 'react';

export const symbol_mediation: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M764-450H511q-12 95-67.5 173T303-155q2 48-30.5 81.5T192-40q-48 0-80-32t-32-80q0-48 32-80t80-32q30 0 54 13t39 38q67-35 110.5-98.5T450-450H297q-10 38-40 60t-65 22q-48 0-80-32t-32-80q0-48 32-80t80-32q35 0 65 22t40 60h153q-11-75-54-138.5T285-747q-15 26-39 38.5T192-696q-48 0-80-32t-32-80q0-48 32-80t80-32q48 0 80.5 33.5T303-805q88 42 142 122t66 173h253l-64-64q-9-9-9-21.5t9-21.5q9-9 21.5-9t21.5 9l116 116q5 5 7 10t2 11q0 6-2 11t-7 10L743-343q-9 9-21 8.5t-21-9.5q-9-9-9-21.5t9-21.5l63-63Z"
		/>
	</svg>
);
